import type * as React from "react";

import type { IBenchmarkOvertimeProps } from "./benchmarkOvertime";
import { BenchmarkOvertime } from "./benchmarkOvertime";

export const SitesVsCategoryOvertime: React.FC<IBenchmarkOvertimeProps> = (props) => {
    // const renderLegend = (selectedChartData) => {
    //     const segmentData = ConversionSegmentsUtils.getSegmentById(props.segmentsData, props.filters.sid);
    //     const segmentDomain = segmentData && segmentData.domain;
    //
    //     return (<LegendsContainer>
    //
    //     </LegendsContainer>);
    // }

    return <BenchmarkOvertime {...props} />;
};
